'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // NPM


var AxisLabels = function (_Component) {
  _inherits(AxisLabels, _Component);

  function AxisLabels() {
    _classCallCheck(this, AxisLabels);

    return _possibleConstructorReturn(this, (AxisLabels.__proto__ || Object.getPrototypeOf(AxisLabels)).apply(this, arguments));
  }

  _createClass(AxisLabels, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labels = _props.labels,
          labelClass = _props.labelClass,
          min = _props.min,
          max = _props.max,
          step = _props.step;
      // lodash range doesn't include the max, so we make sure it's included here

      var ticks = (0, _lodash.range)(min, max + 1, step);
      var width = 100 / (ticks.length - 1);
      return _react2.default.createElement(
        'ul',
        { className: 'AxisLabels' },
        labels.map(function (label, i) {
          var labelTextClass = '';
          if (ticks[label.index] === min) {
            labelTextClass = 'start';
          } else if (ticks[label.index] === max) {
            labelTextClass = 'end';
          }
          var axisLabelStyle = { left: width * label.index + '%' };
          // we want to make sure the string type end labels don't cause the page to overflow horizontally
          if (labelTextClass === 'end' && typeof label.text === 'string') {
            axisLabelStyle = { right: '0px' };
          }
          return _react2.default.createElement(
            'li',
            {
              className: 'AxisLabel ' + _typeof(label.text) + ' ' + labelClass,
              key: i,
              style: axisLabelStyle
            },
            _react2.default.createElement(
              'span',
              { className: 'AxisLabel-text AxisLabel-' + labelTextClass },
              label.text
            )
          );
        })
      );
    }
  }]);

  return AxisLabels;
}(_react.Component);

AxisLabels.propTypes = {
  labels: _propTypes2.default.array.isRequired,
  labelClass: _propTypes2.default.string
};

AxisLabels.defaultProps = {
  labels: [],
  labelClass: ''
};

exports.default = AxisLabels;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/AxisLabels.js
// module id = 129
// module chunks = 0